import * as lightThemeColors from '@prisjakt/design-tokens/light-theme-colors';
import { H4Text } from '@prisjakt/ui/text/variants';
import { layout, media } from 'src/components/base';
import { TextArea } from 'src/components/inputs';
import styled, { css } from 'styled-components';

export const UserQuestion = styled.div`
  flex-grow: 1;
  padding-bottom: ${layout.measurements.spacing200};
  ${media.smallDown`
    padding-bottom: 0;
    padding-top: ${layout.measurements.spacing200};
  `}
`;

export const UserQuestionBox = styled.div<{
  $withRightMargin?: boolean;
}>(
  ({ $withRightMargin = true }) => css`
    min-height: 132px;
    background-color: ${lightThemeColors.staticMaybeBlue100};
    padding: ${layout.measurements.spacing100};
    border-radius: ${layout.measurements.spacing050};
    display: flex;
    margin-left: ${layout.measurements.spacing100};
    ${media.smallDown`
      min-height: 110px;
      margin-left: 0;
    `}

    ${$withRightMargin &&
    css`
      margin-right: ${layout.measurements.spacing100};

      ${media.smallDown`
        margin-right: 0;
      `}
    `}
  `
);

export const QuestionImage = styled.img`
  margin: auto;
`;

export const QuestionText = styled.div`
  width: 100%;
  padding-left: ${layout.measurements.spacing100};
`;

export const QuestionModalBody = styled.div`
  padding: ${layout.measurements.spacing100};
  padding-top: ${layout.measurements.spacing200};
`;

export const QuestionModalBodyCenteredContent = styled.div`
  padding: ${layout.measurements.spacing100};
  padding-top: ${layout.measurements.spacing200};
  display: flex;
  flex-direction: column;
`;

export const BodyMediumTextCentered = styled(H4Text)`
  text-align: center;
  margin: ${layout.measurements.spacing100} 0;
`;

export const QuestionTextInput = styled(TextArea)`
  padding: ${layout.measurements.spacing100} 0;
  textarea {
    border-radius: ${layout.borderRadius};
  }
`;
